export default __webpack_public_path__ + "static/media/granville28.7d2f958a.jpg";